import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import Dropdown from '../Dropdown';
import { Spacer } from '@cleartrip/bento';
import Calendar from '../Calendar';
import Overlay from '../Overlay';
import { isEmpty } from 'helper/isEmpty';
import OutsideClickHandler from '../OutsideClickHandler';
import { getFormattedDate, getInitialMonthRange } from 'helper/dateHelper';
import { align } from 'helper/flyin';
import { langTranslate } from 'helper/arabic'

const CalendarWrapper = (props) => {
	// const isRtl = process.env.CONTENT_DIR === 'RTL'
	const isRtl = align() === "rtl";
	const {
		roundTrip,
		onwardJourny,
		returnJourny,
		departDate,
		returnDate,
		dateClick,
		searchParams,
		// isMulticity = false,
		fromDate,
		index = 1,
    range='',
    setRange=() => {}
		// multiCityDestinations = {}
	} = props;
	const dateformatOptions = { weekday: 'short', month: 'short', day: 'numeric' };
	const [activeOnward, setActiveOnward] = useState(false);
	const [activeReturn, setActiveReturn] = useState(false);
	const [openCalendar, setOpenCalendar] = useState(false);
	const [isRoundTrip, setIsRoundTrip] = useState(roundTrip);
	const [fareCalendar, setfareCalendar] = useState({});
	let formDate = departDate ? new Date(getFormattedDate(departDate, 'MM/DD/YYYY', 'DD/MM/YYYY')) : new Date();

	// if (isMulticity && isEmpty(departDate)) {
	//     formDate = ''
	// } else if (isMulticity) {
	//     formDate = new Date(getFormattedDate(multiCityDestinations[`depart_date_${index}`], 'MM/DD/YYYY', 'DD/MM/YYYY'))
	// }
	const toDate = returnDate ? new Date(getFormattedDate(returnDate, 'MM/DD/YYYY', 'DD/MM/YYYY')) : '';
	// const [range, setRange] = useState({ from: formDate, to: toDate, enteredTo: toDate });
	// const [currencies] = useContext(CurrencyContext)
	// const { conversionRate: { name: selectedCurrencyName = '', symbol: selectedCurrencySymbol = '' } = {} } =
	//     currencies || {}
	useEffect(() => {
		setIsRoundTrip(roundTrip);
		if (!roundTrip) {
			setRange({
				...range,
				to: null,
				enteredTo: null,
			});
		} else {
			if (searchParams.return_date)
				setRange({
					...range,
					to: toDate,
					enteredTo: toDate,
				});
		}
	}, [activeReturn, roundTrip]);
	// useEffect(() => {
	//     if (
	//         !isEmpty(multiCityDestinations[`depart_date_${index}`]) &&
	//         range.from !== multiCityDestinations[`depart_date_${index}`]
	//     ) {
	//         setRange({
	//             ...range,
	//             from: new Date(
	//                 getFormattedDate(multiCityDestinations[`depart_date_${index}`], 'MM/DD/YYYY', 'DD/MM/YYYY')
	//             )
	//         })
	//     }
	// }, [multiCityDestinations])

	// const getDateRangePrice = async departRange => {
	//     const requestParams = {
	//         searchParams: searchParams,
	//         journey: 'onward',
	//         depart_date_range: departRange,
	//         return_date_range: '',
	//         filters: { onward: {} }
	//     }
	//     if (!roundTrip && !activeReturn && !isMulticity) {
	//         const response = await getDateTabFares(requestParams)
	//         const { data: flexiSearchData = {} } = response || {}
	//         if (!isEmpty(flexiSearchData)) {
	//             setfareCalendar(reformFareCalResponse(flexiSearchData))
	//         }
	//     }
	// }
	function handleOnwardClick() {
		// getDateRangePrice(getInitialMonthRange(isMulticity ? fromDate : departDate))
		setActiveOnward(!activeOnward);
		setActiveReturn(false);
		if (openCalendar && !activeReturn) {
			setOpenCalendar(!openCalendar);
		} else {
			setOpenCalendar(true);
		}
	}
	function handleReturnClick() {
		setActiveOnward(false);
		setActiveReturn(!activeReturn);
		setfareCalendar({});
		if (openCalendar && !activeOnward) {
			setOpenCalendar(!openCalendar);
		} else {
			setOpenCalendar(true);
		}
	}
	function directionClick(departRange) {
		// getDateRangePrice(departRange)
	}
	function formatDate(date) {
		let localeOption = 'en-US';
		// if (getCookie('lp') === 'ar' && appPrefix === '/ar') {
		//     localeOption = 'ar'
		// }
    if(align() === 'rtl') {
      localeOption = 'ar';
    }
		if (date) {
			return date.toLocaleDateString(localeOption, dateformatOptions);
		}
	}
	function setDates(dates) {
		setRange({ ...range, ...dates });
		dateClick(dates, range);
		if (isRoundTrip && dates['to']) {
			setOpenCalendar(false);
			setActiveOnward(false);
			setActiveReturn(false);
		}
		if (isRoundTrip && dates['from']) {
			setActiveOnward(false);
			handleReturnClick();
		} else {
			setOpenCalendar(false);
			setActiveOnward(false);
			setActiveReturn(false);
		}
	}

	function outsideCalendar() {
		setOpenCalendar(false);
		setActiveReturn(false);
		setActiveOnward(false);
	}

	function reformFareCalResponse(response) {
		const onward = {};
		const cheapFare = {};
		if (response.onward) {
			response.onward.forEach((elem) => {
				onward[elem.date] = elem;

				const fullMonth = getFormattedDate(elem.date, 'DD-MMMM-YYYY', 'DD/MM/YYYY');
				const month = fullMonth.split('-')[1];
				const curPrice = elem.pr || '-';
				if (cheapFare[month]) {
					if (parseInt(cheapFare[month], 10) > parseInt(curPrice, 10) && curPrice !== '-') {
						cheapFare[month] = curPrice;
					}
				} else if (curPrice !== '-') {
					cheapFare[month] = curPrice;
				}
			});
		}
		return { ...response, onward, cheapFare };
	}
	return (
		<OutsideClickHandler className='p-relative' onOutsideClick={() => outsideCalendar()}>
			<div className='flex flex-middle p-relative'>
				<Dropdown.Select
					className='c-neutral-900'
					width={115}
					// hasError={isMulticity && multiCityDestinations[`depart_date_${index}Error`]}
					active={activeOnward}
					label={formatDate(range['from'])}
					onClick={handleOnwardClick}
					placeHolder={langTranslate('Onward')}
				/>
				<Spacer className='pr-4' />
				<Dropdown.Select
					className='c-neutral-900'
					width={115}
					active={activeReturn}
					label={formatDate(range['to'])}
					disable={true}
					placeHolder={langTranslate('Return')}
					onClick={handleReturnClick}
				/>
				{openCalendar && (
					<>
						<div
							style={{ boxShadow: 'rgba(0, 0, 0, 0.24) 0px 4px 12px 0px', minWidth: '660px', overflowY: 'auto' }}
							className={`br-4 bg-white p-1 p-absolute mt-1 z-30 ${ !isRtl ? "r-0" : "l-0"} t-12 d-none--xs`}
						>
							<ul>
								<div className='px-3 pt-3'>
									{activeReturn ? (
										<span className='c-neutral-900 fs-4 fw-500 zoom-in'>{langTranslate('Return')}</span>
									) : (
										<span className='c-neutral-900 fs-4 fw-500'>{langTranslate('Onward')}</span>
									)}
								</div>
								<Spacer className='pt-3' />
								<Calendar
									isRtl={isRtl}
									className='w-100p'
									selectedDates={range}
									roundTrip={isRoundTrip}
									onClickCalendar={setDates}
									fareCalendar={fareCalendar}
									// directionClick={directionClick}
									activeOnward={activeOnward}
									activeReturn={activeReturn}
									// isMulticity={isMulticity}
									// multiCityDestinations={multiCityDestinations}
									index={index}
								/>
							</ul>
						</div>
						<div
							style={{ boxShadow: 'rgba(0, 0, 0, 0.24) 0px 4px 12px 0px', minWidth: '100%', overflowY: 'auto' }}
							className='DayPicker--xs br-4 bg-white p-1 p-absolute mt-1 z-30 r-0 t-12 d-none d-block--xs'
						>
							<ul>
								<div className='px-3 pt-3'>
									{activeReturn ? (
										<span className='c-neutral-900 fs-4 fw-500 zoom-in'>{langTranslate('Return')}</span>
									) : (
										<span className='c-neutral-900 fs-4 fw-500'>{langTranslate('Onward')}</span>
									)}
								</div>
								<Spacer className='pt-3' />
								<Calendar
									noOfMonths={1}
									isRtl={isRtl}
									className='w-100p'
									selectedDates={range}
									roundTrip={isRoundTrip}
									onClickCalendar={setDates}
									fareCalendar={fareCalendar}
									// directionClick={directionClick}
									activeOnward={activeOnward}
									activeReturn={activeReturn}
									// isMulticity={isMulticity}
									// multiCityDestinations={multiCityDestinations}
									index={index}
								/>
							</ul>
						</div>
					</>
				)}
				{/* <Dropdown.Menu active={openCalendar} distance={-258} className="t-8" width={764}>
                    <Spacer className="pt-3" />
                    <div className="flex flex-between px-3">
                        <div className="flex flex-middle">
                            {activeReturn ? (
                                <span className="c-neutral-900 fs-4 fw-500 zoom-in">Return</span>
                            ) : (
                                <span className="c-neutral-900 fs-4 fw-500">Onward</span>
                            )}
                            {activeReturn ? (
                                !isEmpty(onwardJourny) && !isEmpty(returnJourny) ? (
                                    <span className="px-3 c-neutral-700 fs-4">
                                        {returnJourny} {isRtl ? ' ← ' : ' → '} {onwardJourny}
                                    </span>
                                ) : (
                                    ''
                                )
                            ) : !isEmpty(onwardJourny) && !isEmpty(returnJourny) ? (
                                <span className="px-3 c-neutral-700 fs-4">
                                    {onwardJourny} {isRtl ? ' ← ' : ' → '} {returnJourny}
                                </span>
                            ) : (
                                ''
                            )}
                        </div>
                     
                    </div>
                    <Spacer className="pt-5" />
                    <Calendar
                        isRtl={isRtl}
                        className="w-100p"
                        title="New Delhi → Bangalore"
                        selectedDates={range}
                        roundTrip={isRoundTrip}
                        onClickCalendar={setDates}
                        fareCalendar={fareCalendar}
                        // directionClick={directionClick}
                        activeOnward={activeOnward}
                        activeReturn={activeReturn}
                        // isMulticity={isMulticity}
                        // multiCityDestinations={multiCityDestinations}
                        index={index}
                    />
                </Dropdown.Menu> */}
				{openCalendar && ReactDOM.createPortal(<Overlay className='z-20' />, document.body)}
			</div>
		</OutsideClickHandler>
	);
};

export default CalendarWrapper;
